export default __webpack_public_path__ + "static/media/camera-roll.cf839356.svg";